import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutComponent } from './layout/layout.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HeaderComponent } from './layout/header/header.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { RouterModule, Routes } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ApplicationPipesModule } from './helper/ApplicationPipes.module';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalSuccessComponent } from './modal/modal-success/modal-success.component';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ModalQualificationComponent } from './modal/modal-qualification/modal-qualification.component';
import { ModalSaveSuccessComponent } from './modal/modal-save-success/modal-save-success.component';
import { ModalVerificationEmailComponent } from './modal/modal-verification-email/modal-verification-email.component';
import { ModalAprovalComponent } from './modal/modal-approval/modal-approval.component';
import { ModalPrivacyPoliticiesComponent } from './modal/modal-privacy-policies/modal-privacy-policies.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatGridListModule } from '@angular/material/grid-list';
/** services */

import { CommonService } from '@shared/service/common.service';
import { GenericSliderService } from '@shared/service/genericSlider.service';
import { CutsProjectService } from '@shared/service/custProject.service';
import { ProductFamilyService } from '@shared/service/productFamily.service';
import { SiteService } from '@shared/service/site.service';
import { UserService } from '@shared/service/user.service';
import { NavService } from '@shared/service/nav.service';

/* material stuff */
import { MatButtonModule } from '@angular/material/button';
import { NgxLoadingModule } from 'ngx-loading';
import { LoadingModule } from './loading/loading.module';
import { ModalSMSComponent } from './modal/modal-sms/modal-sms.component';
import { ModalErrorComponent } from './modal/modal-error/modal-error.component';
import { ModalConfirmationComponent } from './modal/modal-confirmation/modal-confirmation.component';
import { ItemService } from './service/items.service';
import { ModelsService } from './service/models.service';
import { ModalBranchOfficeComponent } from './modal/modal-branch-office/modal-branch-office.component';
import { ModalFiltersComponent } from './modal/modal-filters/modal-filters.component';
import { ModalProjectDetailComponent } from './modal/modal-project-detail/modal-project-detail.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalAddToShoppingCartComponent } from './modal/modal-add-to-shopping-cart/modal-add-to-shopping-cart.component';
import { AddToShoppingCartService } from './service/addToShoppingCart.service';
import { SettingService } from './service/setting.service';
import { TransformarTextoPipe } from 'app/transformar-texto.pipe';
import { NgxMaskModule } from 'ngx-mask';
import { MatTabsModule } from '@angular/material/tabs';
import { ModalConfigServicesComponent } from './modal/modal-config-services/modal-config-services.component';
import { ModalConfigPvbComponent } from './modal/modal-config-pvb/modal-config-pvb.component';
import { ModalNoyesComponent } from './modal/modal-noyes/modal-noyes.component';
import { ModalAddUserAccountComponent } from './modal/modal-add-user-account/modal-add-user-account.component';
import { ModalBrcAuthorizationComponent } from './modal/modal-brc-authorization/modal-brc-authorization.component';
import { ModalPrefaDistributionComponent } from './modal/modal-prefa-distribution/modal-prefa-distribution.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ModalDownloadQuoteComponent } from './modal/modal-download-quote/modal-download-quote.component';
/* our own custom components */
const routes: Routes = [{ path: '', component: LayoutComponent }];
@NgModule({
    imports: [
        /* angular stuff */
        CommonModule,
        BrowserAnimationsModule,
        RouterModule.forChild(routes),
        /* 3rd party components */
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatCheckboxModule,
        MatMenuModule,
        MatBadgeModule,
        MatDividerModule,
        MatToolbarModule,
        MatListModule,
        MatSidenavModule,
        MatDialogModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        MatTableModule,
        MatGridListModule,
        MatButtonModule,
        NgxLoadingModule,
        LoadingModule,
        MatInputModule,
        MatAutocompleteModule,
        MatExpansionModule,
        NgbModule,
        MatTooltipModule,
        NgxMaskModule.forRoot(),
        /** your own custom components */
        ApplicationPipesModule,
        MatTabsModule,
    ],
    entryComponents: [
        ModalSMSComponent,
        ModalQualificationComponent,
        ModalSaveSuccessComponent,
        ModalVerificationEmailComponent,
        ModalAprovalComponent,
        ModalPrivacyPoliticiesComponent,
        ModalSuccessComponent,
        ModalErrorComponent,
        ModalConfirmationComponent,
        ModalBranchOfficeComponent,
        ModalFiltersComponent,
        ModalProjectDetailComponent,
        ModalAddToShoppingCartComponent,
        ModalConfigServicesComponent,
        ModalConfigPvbComponent,
        ModalAddUserAccountComponent,
        ModalPrefaDistributionComponent,
    ],
    declarations: [
        /* custom components */
        LayoutComponent,
        FooterComponent,
        HeaderComponent,
        // ProductCardComponent,
        ModalSuccessComponent,
        ModalSMSComponent,
        ModalQualificationComponent,
        ModalSaveSuccessComponent,
        ModalVerificationEmailComponent,
        ModalAprovalComponent,
        ModalPrivacyPoliticiesComponent,
        ModalErrorComponent,
        ModalConfirmationComponent,
        ModalBranchOfficeComponent,
        ModalFiltersComponent,
        ModalProjectDetailComponent,
        ModalAddToShoppingCartComponent,
        ModalConfigServicesComponent,
        ModalConfigPvbComponent,
        ModalNoyesComponent,
        ModalAddUserAccountComponent,
        ModalBrcAuthorizationComponent,
        ModalPrefaDistributionComponent,
        ModalDownloadQuoteComponent,
    ],
    exports: [
        /* angular stuff */
        CommonModule,
        RouterModule,
        /* 3rd party components */
        MatIconModule,
        MatMenuModule,
        MatDividerModule,
        MatToolbarModule,
        MatListModule,
        MatSidenavModule,
        MatDialogModule,
        /** custom components */
        MatButtonModule,
        /* our own custom components */
        MatExpansionModule,
        LayoutComponent,
        FooterComponent,
        HeaderComponent,
        ModalSuccessComponent,
        ModalSMSComponent,
        ModalQualificationComponent,
        ModalSaveSuccessComponent,
        ModalVerificationEmailComponent,
        ModalAprovalComponent,
        ModalPrivacyPoliticiesComponent,
        ModalErrorComponent,
        ModalConfirmationComponent,
        ModalBranchOfficeComponent,
        ModalFiltersComponent,
        ModalProjectDetailComponent,
        ModalAddToShoppingCartComponent,
        ModalConfigServicesComponent,
        ModalConfigPvbComponent,
        ModalAddUserAccountComponent,
        ModalPrefaDistributionComponent,
    ],
    providers: [
        /** custom services */
        CommonService,
        GenericSliderService,
        CutsProjectService,
        ProductFamilyService,
        SiteService,
        UserService,
        ItemService,
        ModelsService,
        NavService,
        AddToShoppingCartService,
        SettingService,
        TransformarTextoPipe
    ]
})
export class SharedModule { }
